module.exports = new __parcel__URL__("bookshelf.927aa83b.webp").toString();